import React from 'react'
import PropTypes from 'prop-types'
import classes from './index.module.css'
import CreateOrganizationArtistsRow from './CreateOrganizationArtistsRow'
import CreateOrganizationArtistsBlock from './CreateOrganizationArtistsBlock'
import ArtistPreview from '../ArtistPreview'

export default function CreateOrganizationSortedArtistsList({
  artists,
  refetchRef,
}) {
  const sortedArtists = artists.reduce((acc, artist) => {
    const firstLetter = artist.name.charAt(0)
    const letterIndex = acc.findIndex(
      item => item.letter.toLowerCase() === firstLetter.toLowerCase()
    )
    if (letterIndex === -1) {
      acc.push({
        letter: firstLetter.toUpperCase(),
        artists: [artist],
      })
    } else {
      acc[letterIndex] = {
        ...acc[letterIndex],
        artists: [...acc[letterIndex].artists, artist].sort((a, b) =>
          a.name.localeCompare(b.name)
        ),
      }
    }
    return acc.sort((a, b) => a.letter.localeCompare(b.letter))
  }, [])

  return (
    <ul className={classes.list}>
      {sortedArtists.map((block, index) => {
        const isLastCol = index === sortedArtists.length - 2
        return (
          <li
            className={classes.list__item}
            key={index}
            ref={isLastCol ? refetchRef : null}
            id={isLastCol ? 'refetchRef' : null}
          >
            <CreateOrganizationArtistsBlock title={block.letter}>
              <CreateOrganizationArtistsRow artists={block.artists}>
                <ArtistPreview />
              </CreateOrganizationArtistsRow>
            </CreateOrganizationArtistsBlock>
          </li>
        )
      })}
    </ul>
  )
}

CreateOrganizationSortedArtistsList.propTypes = {
  artists: PropTypes.array,
  stepData: PropTypes.array,
  fetchNextPage: PropTypes.func,
  handleRemoveArtist: PropTypes.func,
  onChange: PropTypes.func,
  hasNextPage: PropTypes.bool,
  isFetchingNextPage: PropTypes.bool,
  isLoading: PropTypes.bool,
  refetchRef: PropTypes.func,
}
